// extracted by mini-css-extract-plugin
export default {"container":"SettingsFrame_container__7pNDe"};